// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../ASSETS/LOGO/homebg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_homepagecontainer__cqw0K {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  margin: 0;
  padding: 0;
  position: relative;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.home_imageContainer__Q7Drs {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: home_fadeIn__fuE8T 2s;
}

.home_zoomImage__flzX2 {
  height: 200%;
  position: absolute;
  transform-origin: top;
  transition: transform 1s ease-out, top 1s ease-out;
  object-fit: contain;
  opacity: 0.5;
  z-index: 0;
}
.home_zoomImageSettled__0Yoed {
  transform: scale(0.18);
  top: 0;
}

.home_ring__Lh3O8 {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 2px solid #98adb0;
  opacity: 0;
  pointer-events: none;
  z-index: 0;
  width: 0;
  height: 0;
}

.home_ringSettled__Egbde {
  top: calc(1% + (32vh / 2));
}

.home_ringActive__MzOD5 {
  animation: home_expandRing__\\+XLu- 2s ease-out forwards;
}

.home_ring1__18DCy.home_ringActive__MzOD5 {
  animation-name: home_expandRing1__eXm6Y;
  animation: home_expandRing1__eXm6Y 2s ease-out forwards;
}

.home_ring2__I\\+DZt.home_ringActive__MzOD5 {
  animation-name: home_expandRing2__-x6hQ;
  animation: home_expandRing2__-x6hQ 2s ease-out forwards;
}

@keyframes home_expandRing1__eXm6Y {
  0% {
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    width: 200px;
    height: 200px;
    opacity: 0;
  }
}

@keyframes home_expandRing2__-x6hQ {
  0% {
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    width: 300px;
    height: 300px;
    opacity: 0;
  }
}

.home_kurIntText__x10nX {
  position: absolute;
  transform-origin: top;
  z-index: 10;
  width: 30%;
  object-fit: contain;
  transition: transform 1s ease-out;
  transform: scale(1);
}

.home_kurIntTextSettled__aSSUQ {
  margin-top: 2%;
  transform: scale(0.6);
}

.home_heroContainer__TzFKq {
  position: relative;
  margin-top: 30%;
  display: flex;
  justify-content: center;
  width: 100%;
  text-align: center;
}

.home_textContainer__Pf7ni {
  color: #98adb0;
  text-align: center;
  width: 40%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.home_textContainer__Pf7ni h3 {
  font-size: 1rem;
}

.home_textContainerHidden__gNOoO {
  bottom: 100%;
}

.home_highlightText__j-YfE {
  color: #ffe600;
}

.home_partnershipContainer__zB-Y3 {
  margin-top: 10px;
  cursor: pointer;
}

.home_arrow__XG-aE {
  color: #ffe600;
  font-size: 1rem;
  margin: 0;
}

.home_companyContainer__cL5Kd {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 50px;
  z-index: 10;
  margin-bottom: 10%;
  opacity: 0;
  transition: opacity 0.5s ease-out;
}

.home_companyContainerActive__MmaVN {
  opacity: 1;
  animation: home_fadeIn__fuE8T 1s ease-out;
}

.home_partnershipText__vSn2G {
  font-size: 1em;
}

.home_partnershipText__vSn2G:hover {
  color: #ffe600e2;
}

.home_copywright__wWJWz {
  display: block;
  position: fixed;
  bottom: 1em;
  left: 1em;
  color: #98adb0;
  font-size: 0.7em;
}

.home_mainContainer__FLWCL {
  padding: 0;
  margin: 0;
}

@media (max-width: 1024px) {
  .home_homepagecontainer__cqw0K {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    padding: 20px;
    display: block;
    overflow-y: scroll;
  }
  .home_logoSection__uucCY {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  .home_imageContainer__Q7Drs {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: home_zoomOutFadeInMobile__LoVDY 2s;
    margin-top: 30%;
  }

  .home_zoomImage__flzX2 {
    position: absolute;
    width: 100%;
    max-width: 225px;
    opacity: 0.5;
    transform: none !important;
  }

  .home_kurIntText__x10nX {
    position: relative;
    width: 100%;
    max-width: 250px;
    transform: none !important;
    margin-top: 20px;
  }

  .home_ring__Lh3O8 {
    display: none;
  }

  .home_heroContainer__TzFKq {
    margin-top: 2%;
    min-height: 35%;
    width: 100%;
    padding: 20px 0;
    overflow: hidden;
    margin-bottom: 50%;
  }

  .home_textContainer__Pf7ni {
    width: 100%;
    position: relative;
    animation: home_SlideInMobile__tka6z 2s;
  }

  .home_textContainer__Pf7ni h3 {
    font-size: 1em;
    text-align: center;
  }

  .home_companyContainer__cL5Kd {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0;
  }
}

@keyframes home_zoomOutFadeInMobile__LoVDY {
  from {
    opacity: 0;
    transform: scale(2);
  }
  to {
    opacity: 1;
    scale: 1;
  }
}

@keyframes home_fadeIn__fuE8T {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes home_SlideInMobile__tka6z {
  from {
    opacity: 0;
    transform: translateY(1000px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/home.module.css"],"names":[],"mappings":"AAAA;EACE,yDAAoD;EACpD,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gCAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,kDAAkD;EAClD,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uDAA0C;AAC5C;;AAEA;EACE,uCAA2B;EAC3B,uDAA2C;AAC7C;;AAEA;EACE,uCAA2B;EAC3B,uDAA2C;AAC7C;;AAEA;EACE;IACE,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE;IACE,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,yCAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,yDAAoD;IACpD,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6CAAiC;IACjC,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,uCAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,QAAQ;EACV;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".homepagecontainer {\n  background-image: url(\"./../ASSETS/LOGO/homebg.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.imageContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: fadeIn 2s;\n}\n\n.zoomImage {\n  height: 200%;\n  position: absolute;\n  transform-origin: top;\n  transition: transform 1s ease-out, top 1s ease-out;\n  object-fit: contain;\n  opacity: 0.5;\n  z-index: 0;\n}\n.zoomImageSettled {\n  transform: scale(0.18);\n  top: 0;\n}\n\n.ring {\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  border: 2px solid #98adb0;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 0;\n  width: 0;\n  height: 0;\n}\n\n.ringSettled {\n  top: calc(1% + (32vh / 2));\n}\n\n.ringActive {\n  animation: expandRing 2s ease-out forwards;\n}\n\n.ring1.ringActive {\n  animation-name: expandRing1;\n  animation: expandRing1 2s ease-out forwards;\n}\n\n.ring2.ringActive {\n  animation-name: expandRing2;\n  animation: expandRing2 2s ease-out forwards;\n}\n\n@keyframes expandRing1 {\n  0% {\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    width: 200px;\n    height: 200px;\n    opacity: 0;\n  }\n}\n\n@keyframes expandRing2 {\n  0% {\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    width: 300px;\n    height: 300px;\n    opacity: 0;\n  }\n}\n\n.kurIntText {\n  position: absolute;\n  transform-origin: top;\n  z-index: 10;\n  width: 30%;\n  object-fit: contain;\n  transition: transform 1s ease-out;\n  transform: scale(1);\n}\n\n.kurIntTextSettled {\n  margin-top: 2%;\n  transform: scale(0.6);\n}\n\n.heroContainer {\n  position: relative;\n  margin-top: 30%;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n}\n\n.textContainer {\n  color: #98adb0;\n  text-align: center;\n  width: 40%;\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.textContainer h3 {\n  font-size: 1rem;\n}\n\n.textContainerHidden {\n  bottom: 100%;\n}\n\n.highlightText {\n  color: #ffe600;\n}\n\n.partnershipContainer {\n  margin-top: 10px;\n  cursor: pointer;\n}\n\n.arrow {\n  color: #ffe600;\n  font-size: 1rem;\n  margin: 0;\n}\n\n.companyContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 50px;\n  z-index: 10;\n  margin-bottom: 10%;\n  opacity: 0;\n  transition: opacity 0.5s ease-out;\n}\n\n.companyContainerActive {\n  opacity: 1;\n  animation: fadeIn 1s ease-out;\n}\n\n.partnershipText {\n  font-size: 1em;\n}\n\n.partnershipText:hover {\n  color: #ffe600e2;\n}\n\n.copywright {\n  display: block;\n  position: fixed;\n  bottom: 1em;\n  left: 1em;\n  color: #98adb0;\n  font-size: 0.7em;\n}\n\n.mainContainer {\n  padding: 0;\n  margin: 0;\n}\n\n@media (max-width: 1024px) {\n  .homepagecontainer {\n    background-image: url(\"./../ASSETS/LOGO/homebg.png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding: 20px;\n    display: block;\n    overflow-y: scroll;\n  }\n  .logoSection {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n  }\n  .imageContainer {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    animation: zoomOutFadeInMobile 2s;\n    margin-top: 30%;\n  }\n\n  .zoomImage {\n    position: absolute;\n    width: 100%;\n    max-width: 225px;\n    opacity: 0.5;\n    transform: none !important;\n  }\n\n  .kurIntText {\n    position: relative;\n    width: 100%;\n    max-width: 250px;\n    transform: none !important;\n    margin-top: 20px;\n  }\n\n  .ring {\n    display: none;\n  }\n\n  .heroContainer {\n    margin-top: 2%;\n    min-height: 35%;\n    width: 100%;\n    padding: 20px 0;\n    overflow: hidden;\n    margin-bottom: 50%;\n  }\n\n  .textContainer {\n    width: 100%;\n    position: relative;\n    animation: SlideInMobile 2s;\n  }\n\n  .textContainer h3 {\n    font-size: 1em;\n    text-align: center;\n  }\n\n  .companyContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 0;\n  }\n}\n\n@keyframes zoomOutFadeInMobile {\n  from {\n    opacity: 0;\n    transform: scale(2);\n  }\n  to {\n    opacity: 1;\n    scale: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes SlideInMobile {\n  from {\n    opacity: 0;\n    transform: translateY(1000px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homepagecontainer": `home_homepagecontainer__cqw0K`,
	"imageContainer": `home_imageContainer__Q7Drs`,
	"fadeIn": `home_fadeIn__fuE8T`,
	"zoomImage": `home_zoomImage__flzX2`,
	"zoomImageSettled": `home_zoomImageSettled__0Yoed`,
	"ring": `home_ring__Lh3O8`,
	"ringSettled": `home_ringSettled__Egbde`,
	"ringActive": `home_ringActive__MzOD5`,
	"expandRing": `home_expandRing__+XLu-`,
	"ring1": `home_ring1__18DCy`,
	"expandRing1": `home_expandRing1__eXm6Y`,
	"ring2": `home_ring2__I+DZt`,
	"expandRing2": `home_expandRing2__-x6hQ`,
	"kurIntText": `home_kurIntText__x10nX`,
	"kurIntTextSettled": `home_kurIntTextSettled__aSSUQ`,
	"heroContainer": `home_heroContainer__TzFKq`,
	"textContainer": `home_textContainer__Pf7ni`,
	"textContainerHidden": `home_textContainerHidden__gNOoO`,
	"highlightText": `home_highlightText__j-YfE`,
	"partnershipContainer": `home_partnershipContainer__zB-Y3`,
	"arrow": `home_arrow__XG-aE`,
	"companyContainer": `home_companyContainer__cL5Kd`,
	"companyContainerActive": `home_companyContainerActive__MmaVN`,
	"partnershipText": `home_partnershipText__vSn2G`,
	"copywright": `home_copywright__wWJWz`,
	"mainContainer": `home_mainContainer__FLWCL`,
	"logoSection": `home_logoSection__uucCY`,
	"zoomOutFadeInMobile": `home_zoomOutFadeInMobile__LoVDY`,
	"SlideInMobile": `home_SlideInMobile__tka6z`
};
export default ___CSS_LOADER_EXPORT___;
